var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpower(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6517 5.57213C15.6517 2.66647 13.2897 0.304443 10.4028 0.304443C7.51584 0.304443 5.13507 2.66647 5.13507 5.57213C5.13507 7.93416 6.691 9.94001 8.84682 10.5961L0.804688 23.3623H19.9821L11.9399 10.5961C14.0958 9.94001 15.6517 7.93416 15.6517 5.57213ZM7.00969 5.57213C7.00969 3.69751 8.52814 2.17907 10.4028 2.17907C12.2774 2.17907 13.7958 3.69751 13.7958 5.57213C13.7958 7.44676 12.2774 8.9652 10.4028 8.9652C8.52814 8.9652 7.00969 7.42801 7.00969 5.57213ZM4.19776 21.4877L10.384 11.6459L16.5703 21.4877H4.19776Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_89"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.1774,
    height: 23.0579,
    fill: "white",
    transform: "translate(0.804688 0.304443)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpower);
export default __webpack_public_path__ + "static/media/empower.6f545ee1a9b7009024db9f6238fb8da0.svg";
export { ForwardRef as ReactComponent };